import { render, staticRenderFns } from "./ComparisonResults.vue?vue&type=template&id=963cfe9e&scoped=true"
import script from "./ComparisonResults.vue?vue&type=script&lang=js"
export * from "./ComparisonResults.vue?vue&type=script&lang=js"
import style0 from "./ComparisonResults.vue?vue&type=style&index=0&id=963cfe9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963cfe9e",
  null
  
)

export default component.exports